import React, {useContext} from 'react'
import NoticeGlossaryInput from "../../components/inputs/NoticeGlossaryInput";
import FormTranslationContext from "context/FormTranslationContext";
import getObjectValue from "libs/getObjectValue";
import {Collapse} from "@material-ui/core";
import NoticeNumericInput from "../../components/inputs/NoticeNumericInput";
import NoticeDateInput from "../../components/inputs/NoticeDateInput";


function ContractNotDivided(
    {
        id,
        formikProps,
    }) {

    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const realizationPeriod = gVal("realizationPeriod");
    const tenderCompletedWithContract = getObjectValue("form.tenderCompletionData.notDivided.tenderCompletionType", formikProps.values, null) === "zawarcieUmowy";
    const {getDict} = useContext(FormTranslationContext)

    return (<>

        <NoticeDateInput
            formikProps={formikProps}
            id={gId("contractDate")}
            required={tenderCompletedWithContract}
        />

        <NoticeNumericInput
            formikProps={formikProps}
            id={gId("contractValue")}
            required={tenderCompletedWithContract}
        />

        <NoticeGlossaryInput
            id={gId("contractCurrency")}
            formikProps={formikProps}
            items={getDict("SL.MO.043")}
            required={tenderCompletedWithContract}
        />

        <NoticeGlossaryInput
            formikProps={formikProps}
            id={gId("purchaserRealizationRequirements")}
            items={getDict("SL.MO.022")}
            required={false}
            multiple
        />

        <NoticeGlossaryInput
            formikProps={formikProps}
            id={gId("realizationPeriod")}
            items={getDict("ENUM.025")}
            required={tenderCompletedWithContract}
        />

        <Collapse in={realizationPeriod === "DateFromTo"}>
            <NoticeDateInput
                formikProps={formikProps}
                id={gId("realizationPeriodDateFrom")}
                required={tenderCompletedWithContract}
            />
        </Collapse>

        <Collapse
            in={realizationPeriod === "DateFromTo" || realizationPeriod === "DateTo"}>
            <NoticeDateInput
                formikProps={formikProps}
                id={gId("realizationPeriodDateTo")}
                required={tenderCompletedWithContract}
            />
        </Collapse>

        <Collapse
            in={realizationPeriod === "NumberOfDays" || realizationPeriod === "NumberOfMonths"}>
            <NoticeNumericInput
                formikProps={formikProps}
                id={gId("realizationPeriodAmount")}
                required={tenderCompletedWithContract}
            />
        </Collapse>

    </>)
}

ContractNotDivided.propTypes = {};

export default ContractNotDivided;
